export default {
	编号: 'No.:',
	标题: 'Title',
	操作: 'Actions',
	订单编号: 'Order No.',
	发布时间: 'Posted at',
	发起时间: 'Created',
	发送: 'Send',
	附件: 'Attachments',
	工单编号: 'Ticket No.',
	工单不存在: 'Ticket not found',
	工单管理: 'Tickets',
	工单类型: 'Type',
	工单详情: 'Ticket details',
	工单已关闭: 'Ticket closed',
	沟通记录: 'Conversation',
	关闭备注占位: 'Note (optional)',
	关闭工单: 'Close ticket',
	关联订单: 'Related order',
	回复: 'Replies',
	回复内容: 'Reply',
	回复时间: 'Replied at',
	加载中: 'Loading',
	客服: 'Support',
	客户: 'Customer',
	聊天功能即将上线: 'Chat coming soon',
	没有更多: 'No more',
	内容: 'Content',
	请输入订单编号: 'Enter order number',
	请输入工单标题: 'Enter subject',
	请输入工单内容: 'Enter message',
	请输入回复内容: 'Type your reply...',
	请填写内容或上传附件: 'Please write a message or attach a file',
	请选择类型: 'Select ticket type',
	请选择状态: 'Select status',
	确认关闭工单: 'Close this ticket? You can submit a new ticket later if any issue arises.',
	售后工单必须关联订单: 'After-sale ticket must be linked to an order',
	搜索: 'Search',
	无关联: 'None',
	无关联订单: 'No linked order',
	详情: 'Details',
	新增工单: 'New ticket',
	修改: 'Edit',
	修改工单: 'Edit ticket',
	业务员: 'Agent',
	暂无消息: 'No messages yet',
	重置: 'Reset',
	状态: 'Status',
}
